import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {getUrlParameters} from '../../common/util/urlParameters';

export const fetchVehicleChassis = (params = {}) => apiActionCreator({
  'endpoint': `/vehicles/chassis${getUrlParameters(params)}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_VEHICLE_CHASSIS,
    ActionTypes.FETCHED_VEHICLE_CHASSIS,
    [
      ActionTypes.FETCHED_VEHICLE_CHASSIS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const fetchGeneralDataByChassis = (chassis) => apiActionCreator({
  'endpoint': `/vehicles/chassis/${chassis}/general-data`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_GENERAL_DATA_BY_CHASSIS,
    ActionTypes.FETCHED_GENERAL_DATA_BY_CHASSIS,
    [
      ActionTypes.FETCHED_GENERAL_DATA_BY_CHASSIS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const fetchInputDataByChassis = (chassis) => apiActionCreator({
  'endpoint': `/vehicles/chassis/${chassis}/input-data`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_INPUT_DATA_BY_CHASSIS,
    ActionTypes.FETCHED_INPUT_DATA_BY_CHASSIS,
    [
      ActionTypes.FETCHED_INPUT_DATA_BY_CHASSIS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const fetchOutputDataByChassis = (chassis) => apiActionCreator({
  'endpoint': `/vehicles/chassis/${chassis}/output-data`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_OUTPUT_DATA_BY_CHASSIS,
    ActionTypes.FETCHED_OUTPUT_DATA_BY_CHASSIS,
    [
      ActionTypes.FETCHED_OUTPUT_DATA_BY_CHASSIS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});
